<template>
    <el-dialog
        title="券详情"
        v-model="vo.show"
        append-to-body
        :close-on-click-modal="false"
        width="60%"
        :before-close="close"
    >
        <div class="flex between">
            <el-form :model="po" ref="poRef" label-width="80px" inline>
                <el-form-item prop="couponNo" label="券号">
                    <el-input v-model="vo.couponNo" autocomplete="off"></el-input>
                </el-form-item>
                <el-form-item label-width="15px">
                    <el-button @click="resetHandler">重置</el-button>
                    <el-button type="primary" @click="searchHandler">查询</el-button>
                </el-form-item>
            </el-form>
        </div>
        <el-table :data="vo.tableList" style="width: 100%" v-loading="vo.loading">
            <el-table-column prop="couponNo" label="券号"> </el-table-column>
            <el-table-column prop="money" label="面额">{{ props.couponObj.money }} </el-table-column>
            <el-table-column prop="money" label="所属用户"
                ><template #default="{ row }"> {{ row.username }}-{{ row.phone }} </template></el-table-column
            >
            <el-table-column prop="" label="状态">
                <template #default="{ row }"> {{ couponStatus(row.status) }} </template>
            </el-table-column>
            <el-table-column prop="use_time" label="核销时间"> </el-table-column>
        </el-table>
        <div class="pagination-style">
            <el-pagination
                background
                layout="prev, pager, sizes, next"
                :total="vo.total"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
            />
        </div>
        <template #footer>
            <el-button @click="close()">关闭</el-button>
        </template>
    </el-dialog>
</template>
<script setup>
import request from '@/request/index.js';
import { ElMessage } from 'element-plus';
import { reactive, ref } from 'vue';
import { Plus } from '@element-plus/icons-vue';
import { requestDomain } from '../../../package.json';
const props = defineProps({
    visible: Boolean,
    couponObj: Object
});
const emit = defineEmits(['parentCallback', 'closeDialog']);
const vo = reactive({ tableList: [], loading: true, total: 0, show: false, page: 1, perPage: 10, couponNo: '' });
const close = () => {
    emit('closeDialog');
};
const couponStatus = status => {
    if (status === 0) {
        return '未领取';
    } else if (status === 1) {
        return '已领取未使用';
    } else if (status === 2) {
        return '已使用';
    } else if (status === 3) {
        return '已过期';
    }
};
const handleSizeChange = function (e) {
    vo.perPage = e;
    vo.page = 1;
    queryInitHandler();
};
const handleCurrentChange = function (e) {
    vo.page = e;
    queryInitHandler();
};
const queryInitHandler = async function () {
    vo.loading = true;
    const result = await request('queryCouponLists', {
        serialNo: props.couponObj.no,
        page: vo.page,
        perPage: vo.perPage,
        couponNo: vo.couponNo
    });
    const list = result.data.list;
    if (result.data.totalCount === 0) {
        vo.tableList = [];
    } else {
        vo.tableList = list;
    }
    vo.total = result.data.totalCount;
    vo.loading = false;
    vo.show = true;
};
queryInitHandler();
const searchHandler = () => {
    vo.page = 1;
    queryInitHandler();
};
const resetHandler = () => {
    vo.page = 1;
    vo.couponNo = '';
    queryInitHandler();
};
</script>
<style lang="scss">
.selected-role__list {
    width: 100%;
    margin-bottom: 8px;
    flex-wrap: wrap;
}
.mgr {
    margin-right: 8px;
}
.mgt {
    margin-top: 8px;
}
.cascader-lists {
    width: 100%;
}
.attachment-uploader .el-button {
    height: 100px;
    width: 100px;
    border: 1px dashed #cdd0d6;
}
</style>
